<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login Q-Bot</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-alert v-if="error" color="red" type="warning">{{
                  error
                }}</v-alert>
                <v-form>
                  <v-text-field
                    prepend-icon="mdi-account"
                    name="login"
                    label="Email"
                    type="text"
                    v-model="username"
                    @keyup.enter="login"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="mdi-key"
                    name="password"
                    label="Password"
                    type="password"
                    v-model="password"
                    @keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" @click="login" color="primary"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
      loading: false,
    };
  },
  name: "LoginView",
  mounted() {
    this.error = sessionStorage.authMsg;
  },
  methods: {
    login() {
      this.loading = true;
      let that = this;
      axios
        .post("/api/v1/login", {
          email: this.username,
          password: this.password,
        })
        .then((res) => {
          localStorage.sessionToken = res.data.token;
          localStorage.username = this.username;
          that.error = "";
          that.loading = false;
          this.$emit("auth", res.data);
        })
        .catch((err) => {
          that.error = err.response.data;
          that.loading = false;
        });
    },
  },
};
</script>
